import React from 'react';
import type { UnterweisungPublic } from '../../../services/sifa/types';
import { dauerText } from './teilnahmeSeiteLogic';
import { FEHLERKASTEN, HINWEISKASTEN, KNOPF_PRIMAER } from './teilnahmeSeiteStil';

/** Erste Karte: wer unterweist, worum es geht, wie lang es dauert. */
export const Begruessung: React.FC<{
  unterweisung: UnterweisungPublic;
  busy: boolean;
  fehler: string | null;
  /** Nach einem Sitzungsverlust: warum, und der Knopf heisst „Neu beginnen". */
  neustartGrund?: string | null;
  /** Testlauf: kein Nachweis per E-Mail — der Schlusssatz sagt das. */
  test?: boolean;
  onBeginnen: () => void;
}> = ({ unterweisung, busy, fehler, neustartGrund = null, test = false, onBeginnen }) => {
  const dauer = dauerText(unterweisung.dauerMin);
  const anzahlAbschnitte = unterweisung.inhalt.length;
  const anzahlFragen = unterweisung.fragen.length;

  return (
    <div className="space-y-5">
      <div className="space-y-1">
        <p className="text-sm font-medium text-slate-500">{unterweisung.bueroName}</p>
        <h1 className="text-2xl font-bold text-slate-900">{unterweisung.titel}</h1>
        <p className="text-slate-600">Unterweisung für {unterweisung.kundeName}</p>
      </div>

      {unterweisung.beschreibung && <p className="text-slate-700 whitespace-pre-line">{unterweisung.beschreibung}</p>}

      <dl className="grid grid-cols-2 gap-3 text-base">
        {dauer && (
          <div className="p-3 bg-slate-50 rounded-xl">
            <dt className="text-sm text-slate-500">Dauer</dt>
            <dd className="font-semibold">{dauer}</dd>
          </div>
        )}
        <div className="p-3 bg-slate-50 rounded-xl">
          <dt className="text-sm text-slate-500">Inhalt</dt>
          <dd className="font-semibold">
            {anzahlAbschnitte} {anzahlAbschnitte === 1 ? 'Abschnitt' : 'Abschnitte'}
          </dd>
        </div>
        <div className="p-3 bg-slate-50 rounded-xl">
          <dt className="text-sm text-slate-500">Verständnisfragen</dt>
          <dd className="font-semibold">
            {anzahlFragen} {anzahlFragen === 1 ? 'Frage' : 'Fragen'}
          </dd>
        </div>
        {unterweisung.gueltigMonate > 0 && (
          <div className="p-3 bg-slate-50 rounded-xl">
            <dt className="text-sm text-slate-500">Nachweis gültig</dt>
            <dd className="font-semibold">{unterweisung.gueltigMonate} Monate</dd>
          </div>
        )}
      </dl>

      <p className="text-slate-600">
        Du liest die Inhalte nacheinander, beantwortest anschließend die Fragen und bestätigst zum Schluss mit
        deinen Angaben und deiner Unterschrift.
        {test
          ? ' Im Testlauf siehst du am Ende die Auswertung — es wird nichts gespeichert und kein Nachweis versendet.'
          : ' Dein Nachweis kommt danach per E-Mail.'}
      </p>

      {neustartGrund && (
        <div className={HINWEISKASTEN} role="status">
          {neustartGrund}
        </div>
      )}
      {fehler && <div className={FEHLERKASTEN}>{fehler}</div>}

      <button type="button" onClick={onBeginnen} disabled={busy} className={KNOPF_PRIMAER}>
        {busy ? 'Einen Moment…' : neustartGrund ? 'Neu beginnen' : test ? 'Test beginnen' : 'Unterweisung beginnen'}
      </button>
    </div>
  );
};
